import type {
  AuthUser,
  BuyItemRequest,
  BuyItemResponse,
  ProfileResponse,
  RenameRequest,
  Wardrobe,
  WearRequest,
} from '@pixelworld/shared';
import { api } from '../../lib/api';

export const fetchProfile = () => api<ProfileResponse>('GET', '/profile');

export const renamePlayer = (request: RenameRequest) =>
  api<{ user: AuthUser }>('PUT', '/profile/display-name', request);

export const wearAvatar = (request: WearRequest) =>
  api<{ wardrobe: Wardrobe }>('PUT', '/profile/avatar', request);

export const buyItem = (request: BuyItemRequest) =>
  api<BuyItemResponse>('POST', '/profile/buy', request);
